import React, { useState } from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import ReviewsErrorMaybe from '../ReviewsErrorMaybe/ReviewsErrorMaybe';
import { Reviews, Heading, ButtonTabNavHorizontal } from '../../../../components';

import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER } from '../../../../util/types';

import css from '../../ProfilePage.module.css';

const DesktopReviews = ({ reviews, queryReviewsError, isBuyer, showReviewAsCustomer }) => {
  const [showReviewsType, setShowReviewsType] = useState(isBuyer ? REVIEW_TYPE_OF_CUSTOMER : REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;

  const desktopReviewTabs = [
    ...(!isBuyer ? [{
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsFromMyCustomersTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeProviderSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
    }] : []),
    ...(showReviewAsCustomer ? [{
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsAsACustomerTitle"
            values={{ count: reviewsOfCustomer.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeCustomerSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
    }] : []),
  ];

  return (
    <div className={css.desktopReviews}>
      <div className={css.desktopReviewsWrapper}>
        <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

        {isReviewTypeProviderSelected ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    </div>
  );
};

export default DesktopReviews;
